const blacklist = [
  '/',
  '/dashboard'
];

export default function isBlacklistedRedirectUrl(url) {
  return blacklist.indexOf(url) >= 0;
};
